// extracted by mini-css-extract-plugin
export default {"startNewApplicationButton":"NoActiveApplication_startNewApplicationButton__qqAh0"};